module.exports = __webpack_public_path__ + "media/images/fallback/photo/list_default-3e9fc3c9c8d8e25a558b0d17950b9bd5.png";